import {
  DialogDescription,
  DialogContent,
  DialogTrigger,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@ui/components';
import { DialogClose, Button } from '@ui/components';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@ui/components';
import { FC } from 'react';

interface RevertConfigurationDialogProps {
  description: string;
  title: string;
  onRevertChanges: () => void;
}

export const RevertConfigurationDialog: FC<RevertConfigurationDialogProps> = ({
  description,
  title,
  onRevertChanges,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="ghost" type="button">
          {t('COMPANY_POLICY.REVERT_DEFAULT_SETTINGS')}
        </Button>
      </DialogTrigger>
      <DialogContent onOpenAutoFocus={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogDescription>{description}</DialogDescription>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="tertiary" type="button" size="large" wide>
              {t('COMPANY_POLICY.CANCEL')}
            </Button>
          </DialogClose>
          <Button onClick={onRevertChanges} size="large" wide>
            {t('COMPANY_POLICY.REVERT')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
